import BaseAPIService from '../base/base-api-service';
import SearchModelProductClass from 'src/model/searchModelProduct.model';

/**
 * This endpoint can receive the next params
 * q: string,
 * size: number,
 * page: number
 */

class SearchModelProductService extends BaseAPIService<
  SearchModelProductClass
> {
  public endpoint: string = '/navapp/v1/search/modelProduct';
  private baseAPI: BaseAPIService<SearchModelProductClass>;

  constructor() {
    super(SearchModelProductClass);
    this.baseAPI = new BaseAPIService(SearchModelProductClass);
  }

  public getResults(
    wordToSearch: string = '',
    page?: number
  ): Promise<SearchModelProductClass> {
    return this.baseAPI.getOneByParams(this.endpoint, {
      q: wordToSearch,
      page
    });
  }

  public getNResults(
    wordToSearch: string = '',
    resultsToShow: number = 0,
    page?: number
  ): Promise<SearchModelProductClass> {
    return this.baseAPI.getOneByParams(this.endpoint, {
      q: wordToSearch,
      size: resultsToShow,
      page
    });
  }
}

const searchModelProductServiceInstance = new SearchModelProductService();
Object.freeze(searchModelProductServiceInstance);

export default searchModelProductServiceInstance;
